// extracted by mini-css-extract-plugin
module.exports = {"updateButton":"oD_xB","updateslide":"oRM67","col2":"W6R7F"};